/**
 * Tabindex to make an element focusable, which will have
 * 1) 0 for sequential keyboard navigation
 * 2) -1 for not sequential keyboard navigation
 */
export var tabIndex = {
    sequentialIndex: '0',
    nonSequentialIndex: '-1',
};
//# sourceMappingURL=tabIndex.js.map